const R = require('ramda');
const { failProofAssign } = require('../utils');
const utils = require('../utils/utils');
const ArchitectureElement = require('./ArchitectureElement');

/** @typedef {import('./AdAccountArchitecture')} AdAccountArchitecture */

/** @type {Project} */
class Project extends ArchitectureElement {
  constructor(obj) {
    super(obj);
    /** @type {string} unique id for this project among all architecture element ids. */
    this.id;
    /** @type {string} The name of the project. */
    this.name;
    /** @type {AdAccountArchitecture} Ad Account Architecture this project is part of. */
    this.architecture;
    this.updateData(obj);
    if (!obj) return;
    failProofAssign(this, obj);
  }

  get level() {
    return 'project';
  }

  get campaigns() {
    const channelCampaignIds = this.channelCampaignIds;
    if (channelCampaignIds && channelCampaignIds.length > 0) {
      return channelCampaignIds
        .map(id => {
          const { channel, channelId } = utils.getInfoFromId(id);
          if (channel === 'adriel') {
            return this.architecture.adrielCampaignsById[channelId];
          } else {
            return this.architecture.campaignsById[id];
          }
        })
        .filter(Boolean);
    }
    return [];
  }

  get objectives() {
    return R.uniq(this.campaigns.map(R.prop('objective')));
  }

  // format() {
  //     return R.omit(['architecture'], this);
  // }

  getJSON() {
    const channelCampaignIds = this.campaigns.map(({ id }) => id);
    return {
      ...R.omit(['architecture', 'FEFormat'], this),
      metric: this.metric,
      channelCampaignIds,
      schedule: this.getSchedule(),
    };
  }
}

module.exports = Project;
